var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-content',{staticClass:"content"},[(_vm.layout === 'Layout3')?_c('div',{staticClass:"layout-3"},[_c('router-view')],1):_c('div',{ref:"ref_content",staticClass:"layout-2"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }